import React, { Component } from 'react';
import 'normalize.css';
import './styles/main.scss';
import { Provider } from 'react-redux';
import store from './config/store';
import Router from './routes/router';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {AMStorage, VersionCheck, Http, Rollbar} from '@app-masters/js-lib';
import FacebookLogin from './utils/facebookLogin';
// import GoogleLogin from './utils/googleLogin';
import System from './utils/system';
import PushNotification from './utils/pushNotification';
import 'nodep-date-input-polyfill';
import VersionLock from './views/versionLockView';

let storage = new AMStorage(window.localStorage);

class App extends Component {
    constructor () {
        super();
        this.state = {
            validVersion: true
        };
    }

    componentWillMount () {
        try {
            // Rollbar
            Rollbar.setup('8e16ec08d8ed46f2af58817e2c0d1d69', 'mobile_' + process.env.NODE_ENV, process.env.APP_VERSION);

            // Version to console
            console.log('ENV / VERSION / RELEASE', process.env.NODE_ENV + ' / ' + process.env.APP_VERSION + ' / ' + process.env.APP_RELEASE);

            // Define the Platform (and OS if Cordova)
            System.definePlatform().then((platform) => {
                if (platform.cordova) {
                    console.log('Running in CORDOVA. The Platform is ' + platform.OS);
                }
                // Login with Facebook
                if (process.env.NODE_ENV === 'development') {
                    FacebookLogin.setup('1462579497189411');
                    // GoogleLogin.setup('1091365206628-buihp29f0jek4tplvam4viho2qjrtl4d.apps.googleusercontent.com');
                } else {
                    FacebookLogin.setup('721054221428979');
                    // GoogleLogin.setup('1091365206628-b54h3d8nou8rgunsk0cure37nas2qvrk.apps.googleusercontent.com');
                }
            }).catch(e => {
                Rollbar.log(e);
                window.alert('Houve um erro inesperado e os programadores responsáveis já foram avisados.');
            });

            // Http
            if (process.env.NODE_ENV === 'development') {
                // Http.setBaseURL('https://ufjf-dev.herokuapp.com/api');
                // Http.setBaseURL('http://192.168.254.113:3000/api');
                Http.setBaseURL('http://localhost:3000/api');
            } else {
                Http.setBaseURL('https://ufjf-prod.herokuapp.com/api');
            }
            Http.setHeaders({
                'content-type': 'application/json',
                'mobile-version': process.env.APP_VERSION,
                'client': 'mobile' // Change it to WEB if Bootstrap is used (rollbar)
            });

            // Version Check
            VersionCheck.setCurrentVersion('mobile', process.env.APP_VERSION);
            VersionCheck.onMinVersionNotSatifies(Http, (version) => {
                console.log('APP VERSION', version);
                this.setState({validVersion: false});
            });
            VersionCheck.onNewVersion(storage).then((version, fromBeta) => {
                if (fromBeta) {
                    storage.clear();
                }
            }).catch((e) => Rollbar.log(e));

            // PushNotification config
            PushNotification.setup();
        } catch (e) {
            Rollbar.log(e);
            window.alert('Houve um erro inesperado e os programadores responsáveis já foram avisados.');
        }
    }

    render () {
        if (this.state.validVersion) {
            return (
                <Provider store={store}>
                    <MuiThemeProvider>
                        <Router />
                    </MuiThemeProvider>
                </Provider>
            );
        } else {
            return (
                <VersionLock />
            );
        }
    }
}

export default (App);


// WEBPACK FOOTER //
// ./src/App.js